module.exports = __webpack_public_path__ + "static/media/yuqi.2e71c695.jpg";